import React from 'react';
import { Link, Markup } from '@landing/ui';
import { Contacts } from 'components/UI';

import * as styles from './Footer.module.scss';

export default function Footer({ anchorLinks }) {
  const currentYear = new Date().getFullYear();
  const captchaText = `Diese Website ist durch reCAPTCHA geschützt und es gelten <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noreferrer noopener">die Datenschutzbestimmungen</a> und <a href="https://policies.google.com/terms?hl=de" target="_blank" rel="noreferrer noopener">Nutzungsbedingungen von Google</a>.`;

  return (
    <footer className={styles.footer}>
      <div className={styles.layout}>
        <div className={styles.top}>
          <Contacts className={styles.contacts} />
          <div className={styles.navigation}>
            {anchorLinks?.map(({ alias, title }) => (
              <Link key={title} className={styles.link} href={alias}>
                {title}
              </Link>
            ))}
          </div>
        </div>
        <p className={styles.copyright}>{`© ${currentYear} Andersenlab.com`}</p>
        <Markup className={styles.captchaText} tag="p">
          {captchaText}
        </Markup>
      </div>
    </footer>
  );
}
